// gatsby-browser.js

import { rootWrapper } from './gatsby-wrapper'

export const wrapRootElement = rootWrapper